import { h } from 'preact';
import Helmet from 'preact-helmet';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Brand } from 'src/environment';
import { appConfigFactory } from 'src/shared/factories/appConfig.factory';

type HeaderText = string;
type LeadText = string;
type BackButtonText = string;
type BackButtonUrl = string;
type ErrorCode = string;

export interface ErrorPageProps {
  headerText?: HeaderText;
  leadText?: LeadText;
  backButtonText?: BackButtonText;
  backButtonUrl?: BackButtonUrl;
  errorCode?: ErrorCode;
}

interface ErrorPageContent {
  header: HeaderText;
  lead: LeadText;
  backButton: BackButtonText;
}

const BrandErrorPageContent: { [brand: string]: ErrorPageContent } = {
  [Brand.GRUBHUB]: {
    header: "Looks like we're missing something",
    lead:
      "We couldn't cook up the page you were looking for because it doesn't exist.",
    backButton: 'Return to the homepage',
  },
  [Brand.SEAMLESS]: {
    header: 'Oops',
    lead:
      'So sorry, but it looks like things got sidetracked on the way to food time. Romaine calm and lettuce get you back to the homepage.',
    backButton: 'Return to the homepage',
  },
};

export function ErrorPage({
  headerText,
  leadText,
  backButtonText,
  backButtonUrl,
  errorCode = '404',
}: ErrorPageProps) {
  const { brand } = appConfigFactory();
  const content: ErrorPageContent = BrandErrorPageContent[brand];
  const header: string = headerText || content.header;
  const lead: string = leadText || content.lead;
  const backText: string = backButtonText || content.backButton;
  const backUrl: string = backButtonUrl || '/';

  return (
    <div
      className={classNames('error-page', 'u-section-6', {
        'error-page--grubhub': brand === Brand.GRUBHUB,
        'error-page--seamless': brand === Brand.SEAMLESS,
      })}
    >
      <Helmet meta={[{ name: 'prerender-status-code', content: '404' }]} />

      <div class="error-page__reason u-stack-y-4">
        <h1 class="error-page__reason-header u-stack-y-6">{header}</h1>
        <p class="lead u-stack-y-8">{lead}</p>
        <p class="u-stack-y-6">
          <Link to={backUrl} title={backText} class="s-btn s-btn-primary">
            {backText}
          </Link>
        </p>
        <p class="caption">{`Error code: ${errorCode}`}</p>
      </div>
      <div className="error-page__image" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/ErrorPage/ErrorPage.tsx